import React from "react";
import { Link as MUILink } from '../../../UI/Link';

import { IProps } from "./types";

export const ExternalLink: React.FC<IProps> = props => (
  <MUILink
    target="_blank"
    rel="nofollow noopener"
    {...props}
  >
    {props.children}
  </MUILink>
);
